var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import Loading from '@doordash/component-loading';
import * as React from 'react';
import { useLocation, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchBootstrapData } from './bootstrap_slice';
import { PORTAL_ROUTE_PREFIX, ERROR_MESSAGE_NOT_LOGGED_IN, } from '../../constants/values';
import { PUBLIC_ROUTES, getPublicRouteComponent } from './PublicRoutes';
import { getStatusForBootstrapAction } from '../../selectors/bootstrap_selector';
import LocationPathHelper from '../../utils/location_path_helper';
import { getIdentityUrl } from '../../utils/identity_helper';
import { BootstrapActions } from '../../constants/actions';
import { BootstrapContainerTestId } from '../testId';
import { isFetchPending, isFetchFulfilled, isFetchRejected, } from '../../utils/fetchStatusHelper';
import { useIsDynamicBooleanEnabled } from '../DynamicValues/hook';
import { DYNAMIC_VALUES_NAME } from '../DynamicValues';
export var fetchBootstrapDataFailed = function (statusForBootstrapAction, errorMessage) {
    return (isFetchRejected(statusForBootstrapAction, BootstrapActions.FETCH_BOOTSTRAP_DATA) && errorMessage === ERROR_MESSAGE_NOT_LOGGED_IN);
};
export var isOnPath = function (routes, path) {
    return routes.some(function (route) { return route === path; });
};
export var BootstrapContainer = function (_a) {
    var protectedRoutes = _a.protectedRoutes;
    var dispatch = useDispatch();
    var statusForBootstrapAction = useSelector(getStatusForBootstrapAction);
    var _b = __read(React.useState(null), 2), errorMsg = _b[0], setErrorMsg = _b[1];
    var location = useLocation();
    var pathname = location.pathname;
    var isOnPublicPath = isOnPath(PUBLIC_ROUTES, pathname);
    var isSelfServeOnboardingEnabled = useIsDynamicBooleanEnabled(DYNAMIC_VALUES_NAME.ddfwSelfServeOnboarding);
    var handleFetchBootstrapDataSuccess = React.useCallback(function () {
        setErrorMsg(null);
    }, [setErrorMsg]);
    var handleFetchBootstrapDataError = React.useCallback(function (errorResponse) {
        setErrorMsg((errorResponse && errorResponse.error) || 'There was an error.');
    }, [setErrorMsg]);
    React.useEffect(function () {
        dispatch(fetchBootstrapData())
            .unwrap()
            .then(handleFetchBootstrapDataSuccess, handleFetchBootstrapDataError);
    }, [handleFetchBootstrapDataSuccess, handleFetchBootstrapDataError, dispatch]);
    if (isFetchPending(statusForBootstrapAction, BootstrapActions.FETCH_BOOTSTRAP_DATA)) {
        return (React.createElement("div", { "data-testid": BootstrapContainerTestId.LoadingSpinner },
            React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 })));
    }
    if (fetchBootstrapDataFailed(statusForBootstrapAction, errorMsg || '') &&
        !isOnPublicPath) {
        var currentPath = LocationPathHelper.getPathName() || PORTAL_ROUTE_PREFIX;
        window.location.href = getIdentityUrl({ nextPath: currentPath });
        return (React.createElement("div", { "data-testid": BootstrapContainerTestId.RedirectLoadingSpinner },
            React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 })));
    }
    var allRoutes = __spread((isSelfServeOnboardingEnabled ? getPublicRouteComponent() : []), (isFetchFulfilled(statusForBootstrapAction, BootstrapActions.FETCH_BOOTSTRAP_DATA)
        ? protectedRoutes
        : []));
    // React.Children.toArray automatically give each child `key`
    var allRoutesWithKeys = React.Children.toArray(allRoutes);
    return React.createElement(Switch, null, allRoutesWithKeys);
};
export default BootstrapContainer;
